import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { MrfiktivDocumentIdsAiDtoGen, MrfiktivDocumentRuleCheckControllerGetParamsGen } from "../v1/data-contracts";
import { DocumentRuleCheck } from "../v1/DocumentRuleCheck";
import { HttpClient } from "../v1/http-client";

/**
 * Communicate with ai API
 */
class AiService {
  mrfiktivProxy: DocumentRuleCheck;
  client: HttpClient;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.client = mrfiktivHttpClientProvider.client();
    this.mrfiktivProxy = new DocumentRuleCheck(this.client);
  }

  /**
   * Get all ai results
   */
  async create(partnerId: string, data: MrfiktivDocumentIdsAiDtoGen) {
    return (await this.mrfiktivProxy.documentRuleCheckControllerAnalysesDocumentRulesForImages(partnerId, data)).data;
  }

  /**
   * Get all ai results
   */
  async get(data: MrfiktivDocumentRuleCheckControllerGetParamsGen) {
    return (await this.mrfiktivProxy.documentRuleCheckControllerGet(data)).data;
  }

  /**
   * Get one result
   */
  async getOne(partnerId: string, id: string) {
    return (await this.mrfiktivProxy.documentRuleCheckControllerGetOne(partnerId, id)).data;
  }

  /**
   * Close (archive) a document rule check
   */
  async close(partnerId: string, id: string) {
    return (await this.mrfiktivProxy.documentRuleCheckControllerClose(partnerId, id)).data;
  }

  /**
   * Reopen (un-archive) a closed document rule check
   */
  async reopen(partnerId: string, id: string) {
    return (await this.mrfiktivProxy.documentRuleCheckControllerReopen(partnerId, id)).data;
  }

  /**
   * (ADMIN) Delete a document rule check
   */
  async delete(partnerId: string, id: string) {
    return (await this.mrfiktivProxy.documentRuleCheckControllerDelete(partnerId, id)).data;
  }
}

/**
 * Communicate with ai API
 */
export default new AiService(new MrfiktivHttpClientProvider());
